export default (groupId) => `id${groupId}`;
